import { createStore } from 'vuex'

export default createStore({
  state: {
    personInfo: '',
    configInfo: null,
    signatureImage: ''
  },

  getters: {
    configInfo: state => state.configInfo,
    signatureImage: (state: any) => state.signatureImage,
  },

  mutations: {
    SET_CONFIGINFO: (state, configInfo) => {
      state.configInfo = configInfo
    },
    SET_SIGNATURE_IMAGE: (state: any, image: string) => {
      state.signatureImage = image
    },
  },

  actions: {
    setConfigInfo({ commit }, data) {
      commit('SET_CONFIGINFO', data)
    },
    setSignatureImage({ commit }, image: string) {
      commit('SET_SIGNATURE_IMAGE', image)
    },
  },

  modules: {
  }
})
